import React from "react";
import NewLoaderLogo from "../../assets/images/newloader.gif";

const GifLoader = () => {
  return (
    <div className="loader">
      <img
        src={NewLoaderLogo}
        alt="Loader"
        className="userImage"
        width="100"
        height="100"
      />
    </div>
  );
};

export default GifLoader;
